import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';

class Nativo extends Component {

  static propTypes = {
    url: PropTypes.string,
    runScript: PropTypes.bool,
    renderMetaTags: PropTypes.bool,
    divName: PropTypes.string
  }

  static defaultProps = {
    url: "https://s.ntv.io/serve/load.js",
    runScript: true,
    renderMetaTags: false
  }

  render() {
    const { url, runScript, renderMetaTags, divName } = this.props;

    let metaTags;
    let script;

    if (runScript) {
      script = [{
        'src': url,
        'type': 'text/javascript',
        'async': true
      }];
    }

    if (renderMetaTags) {
      metaTags = [
        { 'http-equiv': 'X-UA-Compatible', 'content': 'IE=edge' },
        { 'name': 'robots', 'content': 'noindex, nofollow' }
      ];
    }

    return (
      <div id={divName}>
        <Helmet
        meta={metaTags}
        script={script}
        />
      </div>
      );
  }
}

export default Nativo;



// WEBPACK FOOTER //
// ./app/components/ads/Nativo.js